module.exports = __webpack_public_path__ + "static/img/donate-blood-02.4e946da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/donate-blood-02.jpg
// module id = 40TM
// module chunks = 100